export default "__VITE_ASSET__3354c787__"